<template>
  <div>
    <div class="col-12 bg-primary py-4 text-center">
      <LogoPublic />
    </div>
    <div class="col-12 py-4 text-center">
      <h4>The system is currently undergoing maintenance</h4>
      <h5>The system will be available again Sunday, September 14th at 17:00 (Central European Time). We apologise for any inconvenice this may cause. For more information, please contact support at <a href="mailto: support@gdq.se">support@gdq.se</a></h5>
    </div>
  </div>
</template>
<script>
import LogoPublic from './LogoPublic.vue'
export default {
  name: 'MaintenanceMode',
  components: {
    LogoPublic
  }
}
</script>
